export const TERMS_URL = "https://www.offstreet.com/terms-of-use";
export const PRIVACY_URL = "https://www.offstreet.com/privacy-policy";
